<template>
    <div>
        <public-head title="搜索"></public-head>
        <div class="search">
            <input
                class="search-content"
                placeholder="请输入院校名称/城市"
                focus="{true}"
                v-model="value"
                v-on:keyup="search"
               
            />
            <div class="button">
                <img
                    class="search-icon"
                    src="https://new.schoolpi.net/attach/small_program/class/search.png"
                />
            </div>
            <!-- -->
            <div class="_search-list">
                <div v-for="(item,index) in searchList" :key="index">
                    <div class="search-list-item" @click="searchSchoolName(item)">{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="search-recommend">
            <div class="search-title">为你推荐</div>
            <div class="search-list">
                <div v-for="(item,index) in recommend" :key="index">
                    <div
                        class="list-item"
                        :style="{'color':(item.color)}"
                        @click="goHostDetail(item.name)"
                    >{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="mt search-recommend">
            <div class="search-title">大家都在搜</div>
            <div class="search-list">
                <div v-for="(item,index) in hostList" :key="index">
                    <div
                        class="item"
                        :style="{'background':item.color}"
                        @click="goHostDetail(item.name)"
                    >{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
    data() {
        return {
            searchList: [],
            recommend: [], //推荐
            hostList: [], //热搜
            name: "",
            go: 0,
            value: ""
        };
    },
    created() {},
    methods: {
       
        // 进入学校详情
        searchSchoolName(e) {
            
            this.$router.push({
                path: "/fenlei/HostDetail",
                query: {
                    sid: e.sid
                }
            });
        },
        goHostDetail(e) {
            this.$router.push({
                path: "/fenlei/HostDetail",
                query: {
                    name: e
                }
            });
        },
        // 搜索框触发的事件
        search() {
            httpPost("/classifie/search_list", {
                name: this.value
            }).then(res => {
               
                if (res.code == 1 && res.list.length > 0) {
                    this.searchList = res.list;
                } else {
                    this.searchList = [];
                }
            });
        },
        // 获取搜索接口数据
        fetchsearch() {
            httpPost("/classifie/search", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
               
                if (res.code === 1) {
                    (this.recommend = res.list1), (this.hostList = res.list2);
                }
            });
        }
    },
    mounted() {
        this.fetchsearch();
        // this.fetchHostSchool();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
page {
    background: #f2f2f2;
}

.search {
    margin-top: 46px;
    background: #22d8d9;
    position: relative;
    padding: 0.5rem 0;
}
._search-list {
    /* border: 1px solid #ccc; */
    overflow: hidden;
    background-color: #fff;
    position: absolute;
    left: 3.125rem;
    right: 3.75rem;
    z-index: 9;
    border-radius: 10px;
}

.search-list-item {
    height: 1.875rem;
    line-height: 1.875rem;
    color: #000;
    font-size: 0.875rem;
    padding-left: 0.625rem;
    font-weight: bold;
    background: #faf6f6;
}

.search-content {
    margin: 0 3.125rem 0 0.9375rem;
    height: 1.875rem;
    background: #fff;
    border-radius: 30px;
    font-size: 0.8125rem;
    padding-left: 0.9375rem;
    width: 82%;
    border: 0;
    outline: none;
}

.search-icon {
    width: 1.5625rem;
    height: 1.5625rem;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    right: 0.9375rem;
}

.search-recommend {
    background: #fff;
}

.search-title {
    font-size: 1.125rem;
    padding: 1.25rem 0.9375rem;
}

.search-list {
    margin: 0 0.9375rem;
    display: flex;
    flex-wrap: wrap;
}

.list-item {
    margin: 0 3.125rem 1.25rem 0;
    font-size: 0.9375rem;
}

.item {
    padding: 0.625rem;
    background-color: #ff7373;
    border-radius: 1.25rem;
    margin: 0 0.625rem 0.625rem 0;
    color: #fff;
    font-size: 12px;
}

.mt {
    margin-top: 0.625rem;
}
</style>